import { render, staticRenderFns } from "./suggestionDetail.vue?vue&type=template&id=49a9aab7"
import script from "./suggestionDetail.vue?vue&type=script&lang=js"
export * from "./suggestionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a9aab7')) {
      api.createRecord('49a9aab7', component.options)
    } else {
      api.reload('49a9aab7', component.options)
    }
    module.hot.accept("./suggestionDetail.vue?vue&type=template&id=49a9aab7", function () {
      api.rerender('49a9aab7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sug/suggestionDetail.vue"
export default component.exports